"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _theme = _interopRequireDefault(require("../../../theme"));

var _Card = _interopRequireDefault(require("../../Card"));

var _TableContext = _interopRequireDefault(require("./TableContext"));

var _TableCell = _interopRequireDefault(require("./TableCell"));

var _TableHead = _interopRequireDefault(require("./TableHead"));

var _TableHeaderCell = _interopRequireDefault(require("./TableHeaderCell"));

var _TableRow = _interopRequireDefault(require("./TableRow"));

var _TableBody = _interopRequireDefault(require("./TableBody"));

var _TextTableCell = _interopRequireDefault(require("./TextTableCell"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Table = (0, _react.forwardRef)(function (_ref, ref) {
  var scrolling = _ref.scrolling,
      responsive = _ref.responsive,
      spacing = _ref.spacing,
      props = _objectWithoutProperties(_ref, ["scrolling", "responsive", "spacing"]);

  var _React$useState = _react["default"].useState({}),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      contextValue = _React$useState2[0],
      setContextValue = _React$useState2[1];

  _react["default"].useEffect(function () {
    setContextValue({
      scrolling: scrolling,
      responsive: responsive,
      spacing: spacing
    });
  }, [scrolling, responsive, spacing]);

  return _react["default"].createElement(_TableContext["default"].Provider, {
    value: contextValue
  }, _react["default"].createElement(_Card["default"], _extends({
    ref: ref
  }, props)));
});
Table.defaultProps = {
  theme: _theme["default"],
  spacing: 'default',
  border: 'light',
  scrolling: false,
  responsive: false
};
Table.Cell = _TableCell["default"];
Table.Head = _TableHead["default"];
Table.Row = _TableRow["default"];
Table.HeaderCell = _TableHeaderCell["default"];
Table.Body = _TableBody["default"];
Table.TextCell = _TextTableCell["default"];
var _default = Table;
exports["default"] = _default;